import { home } from 'routes/config';
import { Navigate, Route, Routes } from 'react-router-dom';
import { performanceRoutes } from './Performance';
import { callLogsRoutes } from './CallLogs';
import { configureRoutes } from './Configure';
import { signalsRoutes } from './Signals';
import { chatLogsRoutes } from './ChatLogs';

export default function AgentRoutes() {
  return (
    <Routes>
      <Route index={true} element={<Navigate to={home.performance} replace />} />
      {performanceRoutes}
      {callLogsRoutes}
      {chatLogsRoutes}
      {signalsRoutes}
      {configureRoutes}
      <Route path='*' element={<Navigate to='/404' replace />} />
    </Routes>
  );
}
